const IMAGES = {
    "misc": [
        // require("@frog/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-attack.png"),
        // require("@frog/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-support.png"),
        // require("@frog/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-reposition.png"),
        // require("@frog/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-harvest.png"),
        // require("@frog/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-kindle.png"),
    ],
    "faces": {
        // "human": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.human.png"),
        // "wolf": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.wolf.png"),
        // "fox": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.fox.orange.png"),
        // "white-fox": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.fox.png"),
        // "bunny": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.bunny.png"),
        // "boar": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.boar.png"),
        // "imp": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.imp.png"),
        // "devil": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.devil.png"),
        // "devilscream": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.devil.scream.png"),
        // "knight": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.knight.png"),
        // "skull": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.skull.png"),
        // "goblin": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.goblin.png"),
        // "hobgoblin": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.hobgoblin.png"),
        // "kobold": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.kobold.png"),
        // "dwarf": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.dwarf.png"),
        // "archdwarf": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.archdwarf.png"),
        // "orc": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.orc.png"),
        // "lich": require("@frog/source/assets/images/frog-tactics/stage/units/parts/head.lich.png"),
    },
    "bodies": {
        // "good": require("@frog/source/assets/images/frog-tactics/stage/units/parts/body.good.png"),
        // "bad": require("@frog/source/assets/images/frog-tactics/stage/units/parts/body.bad.png"),
        // "imp": require("@frog/source/assets/images/frog-tactics/stage/units/parts/body.imp.png"),
        // "none": require("@frog/source/assets/images/frog-tactics/stage/units/parts/body.none.png"),
        // "neutral": require("@frog/source/assets/images/frog-tactics/stage/units/parts/body.none.png"),
        // "devil": require("@frog/source/assets/images/frog-tactics/stage/units/parts/body.devil.png"),
    },
    "weapons": {
        // ?
    },
    "portraits": {
        // ?
    },
    "decals": {
        // "red-helmet": require("@frog/source/assets/images/frog-tactics/stage/units/parts/decal.helmet.red.png"),
        // "blue-helmet": require("@frog/source/assets/images/frog-tactics/stage/units/parts/decal.helmet.blue.png"),
        // "green-helmet": require("@frog/source/assets/images/frog-tactics/stage/units/parts/decal.helmet.green.png"),
        // "grimrawr": require("@frog/source/assets/images/dungeon-tactics/grimrawr.png"),
    },
    "images": {
        "red": require("@frog/source/assets/images/frog-tactics/stage/units/red.png"),
        "red-tetromino": require("@frog/source/assets/images/frog-tactics/stage/units/red-tetromino.png"),
        // "prince": require("@frog/source/assets/images/teach-tactics/mapsprite-PRINCE.png"),
    },
    "arrow": {
        "north-end": require("@frog/source/assets/images/hero-tactics-ii/arrow/north-end.png"),
        "north-start": require("@frog/source/assets/images/hero-tactics-ii/arrow/north-start.png"),
        "south-end": require("@frog/source/assets/images/hero-tactics-ii/arrow/south-end.png"),
        "south-start": require("@frog/source/assets/images/hero-tactics-ii/arrow/south-start.png"),
        "east-end": require("@frog/source/assets/images/hero-tactics-ii/arrow/east-end.png"),
        "east-start": require("@frog/source/assets/images/hero-tactics-ii/arrow/east-start.png"),
        "west-end": require("@frog/source/assets/images/hero-tactics-ii/arrow/west-end.png"),
        "west-start": require("@frog/source/assets/images/hero-tactics-ii/arrow/west-start.png"),
        "north-west": require("@frog/source/assets/images/hero-tactics-ii/arrow/north-west.png"),
        "north-east": require("@frog/source/assets/images/hero-tactics-ii/arrow/north-east.png"),
        "south-west": require("@frog/source/assets/images/hero-tactics-ii/arrow/south-west.png"),
        "south-east": require("@frog/source/assets/images/hero-tactics-ii/arrow/north-east.png"),
        "east-west": require("@frog/source/assets/images/hero-tactics-ii/arrow/east-west.png"),
        "north-south": require("@frog/source/assets/images/hero-tactics-ii/arrow/north-south.png"),
    },
}

import games from "./games"
Object.values(games).forEach((game) => {
    if(game.images != undefined) {
        Object.keys(game.images).forEach((imageType) => {
            if(IMAGES[imageType] == undefined) {
                IMAGES[imageType] = {}
            }
            IMAGES[imageType] = {
                ...IMAGES[imageType],
                ...game.images[imageType]
            }
        })
    }
})

export default IMAGES
